import React from "react";
import { useNavigate } from "react-router-dom";
import payment from "../../assets/Register.png";
import box from "../../assets/box.png";
import paymentL from "../../assets/paymentL.png";

const SellerDashboard = () => {
  const navigate = useNavigate();

  const _handleGo = () => {
    const SellerLogin = localStorage.getItem("SellerloginData");
    if (SellerLogin) {
      navigate("/GstRegistration");
    } else {
      navigate("/SellerRegister");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <section className="bg-white p-6 shadow-md text-center ">
        <h2 className="text-3xl font-bold mb-2 mt-3">
          Become an BharatCOD Seller
        </h2>
        <p className="text-lg text-gray-600 mb-4">
          Start selling and grow your business with BharatCOD.
        </p>
        <button
          onClick={() => _handleGo()}
          className="bg-blue-600 text-white px-6 py-3 rounded text-lg hover:bg-blue-700"
        >
          Register Now
        </button>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6">
        <div className="bg-white p-6 shadow rounded-lg text-center border border-gray-200">
          <h3 className="text-lg font-semibold">Sell with Ease</h3>
          <p className="text-gray-600">
            List your products and reach millions of customers.
          </p>
        </div>
        <div className="bg-white p-6 shadow rounded-lg text-center border border-gray-200">
          <h3 className="text-lg font-semibold">Fast & Secure Payments</h3>
          <p className="text-gray-600">
            Get payments deposited directly to your account.
          </p>
        </div>
        <div className="bg-white p-6 shadow rounded-lg text-center border border-gray-200">
          <h3 className="text-lg font-semibold">World-Class Support</h3>
          <p className="text-gray-600">Get assistance whenever you need it.</p>
        </div>
      </div>

      <section className="p-6 bg-white shadow-md">
        <h2 className="text-2xl font-bold mb-4 text-center">
          How to Start Selling?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 border border-gray-200 rounded text-center">
            <img
              src={payment}
              alt="Register"
              className="w-24 h-24 mx-auto mb-2"
            />
            <h3 className="font-semibold">1. Register</h3>
            <p className="text-gray-600">
              Create your seller account on bharatCod.
            </p>
          </div>

          {/* Step 2: List Products */}
          <div className="p-4 border border-gray-200 rounded text-center">
            <img src={box} alt="Register" className="w-24 h-24 mx-auto mb-2" />
            <h3 className="font-semibold">2. List Products</h3>
            <p className="text-gray-600">Add your products with ease.</p>
          </div>

          {/* Step 3: Start Selling */}
          <div className="p-4 border border-gray-200 rounded text-center">
            <img
              src={paymentL}
              alt="Register"
              className="w-24 h-24 mx-auto mb-2"
            />
            <h3 className="font-semibold">3. Start Selling</h3>
            <p className="text-gray-600">Reach millions of buyers.</p>
          </div>
        </div>
      </section>

      <footer className="bg-gray-800 text-white text-center p-4 mt-6 bottom-0 w-full">
        <p>&copy; 2025 BharatCOD Seller. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default SellerDashboard;
